var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex cursor-pointer",style:(_vm.style),on:{"click":function($event){return _vm.onInput(true)}}},[_c('svg-plus-circle',{staticClass:"mr-2",attrs:{"width":"26","height":"23","fill":_vm.style['--primary-color']}}),_c('h3',{staticClass:"w-full text-lg font-bold mb-2"},[_vm._v("Add Secondary Insurance")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }